// extracted by mini-css-extract-plugin
export var animationContainer = "_it-0";
export var asteriskIcon = "_it-8";
export var conversationLeftSection = "_it-4";
export var conversationListItem = "_it-3";
export var conversationMiddleSection = "_it-5";
export var conversationRightSection = "_it-6";
export var detailsContent = "_it-1";
export var listContainer = "_it-7";
export var modalContent = "_it-2";